
import React from 'react'
import Head from "next/head"
import { useTranslation } from '~/i18n'

const MetaTags: React.FC<{}> = (props: any) => {

  const [t] = useTranslation()
  // const { router: { } } = props

  return (
    <Head>
      <title>{t`Giới thiệu mô hình đầu tư - Infina`}</title>
      <meta property='og:title' content={t`Giới thiệu mô hình đầu tư của Infina`} />
      <meta name="description" content={t`Cách đầu tư bất động sản với số vốn nhỏ, sinh lời cao, khoản đầu tư được ngân hàng bảo lãnh, BĐS có pháp lý ổn và tiềm năng tăng giá cao.`} />
    </Head>
  )
}

export default MetaTags
